import { Component } from '@angular/core';

@Component({
  selector: 'ca-bmo-loading',
  templateUrl: './bmo-loading.component.html',
  styleUrls: ['./bmo-loading.component.scss'],
})
export class BmoLoadingComponent {}
